module.exports = __webpack_public_path__ + "static/media/technocate_2_700_100.2a12ff03.png";